import { createSelector } from 'reselect';
import { pendingResponse } from '../../../fetchStatus';
import { serviceSelector } from '../service';

export const serviceLandingpageResponseSelector = createSelector(
    [serviceSelector],
    service => service.serviceLandingpage ?? pendingResponse
);
